export type Procedure = (...args: any[]) => void;

class ApiHelper {
    static debounce<F extends Procedure>(
  func: F,
  wait: number,
  immediate = false
): ((this: ThisParameterType<F>, ...args: Parameters<F>) => void) & { cancel: () => void } {
  let timeoutId: ReturnType<typeof setTimeout> | undefined;

  const debounced = function (this: ThisParameterType<F>, ...args: Parameters<F>) {
    const context = this;

    const later = function () {
      timeoutId = undefined;
      if (!immediate) {
        func.apply(context, args);
      }
    };

    const callNow = immediate && timeoutId === undefined;

    if (timeoutId !== undefined) {
      clearTimeout(timeoutId);
    }

    timeoutId = setTimeout(later, wait);

    if (callNow) {
      func.apply(context, args);
    }
  };

  debounced.cancel = () => {
    if (timeoutId !== undefined) {
      clearTimeout(timeoutId);
      timeoutId = undefined;
    }
  };

  return debounced;
}

}

export default ApiHelper;
